import { cocoaBrownPalette, intentPalette, raisinBlackPalette, umberPalette, whiteSmokePalette } from "../foundations/colors";
export const colors = {
    'background.neutral.primary.default': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'background.neutral.primary.pressed': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'background.neutral.primary.hovered': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'background.neutral.primary.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.neutral.secondary.default': {
        default: whiteSmokePalette.white,
        _dark: whiteSmokePalette.white
    },
    'background.neutral.secondary.hovered': {
        default: whiteSmokePalette.white,
        _dark: whiteSmokePalette.white
    },
    'background.neutral.secondary.pressed': {
        default: whiteSmokePalette.white,
        _dark: whiteSmokePalette.white
    },
    'background.neutral.secondary.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.neutral.tertiary.default': {
        default: cocoaBrownPalette.linen,
        _dark: cocoaBrownPalette.linen
    },
    'background.neutral.tertiary.hovered': {
        default: cocoaBrownPalette.linen,
        _dark: cocoaBrownPalette.linen
    },
    'background.neutral.tertiary.pressed': {
        default: cocoaBrownPalette.linen,
        _dark: cocoaBrownPalette.linen
    },
    'background.neutral.tertiary.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.neutral.inverse.default': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'background.neutral.inverse.hovered': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'background.neutral.inverse.pressed': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'background.neutral.inverse.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.accent.primary.default': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'background.accent.primary.hovered': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'background.accent.primary.pressed': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'background.accent.primary.disabled': {
        default: cocoaBrownPalette.desertSand,
        _dark: cocoaBrownPalette.desertSand
    },
    'background.accent.onContent.default': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'background.accent.onContent.hovered': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'background.accent.onContent.pressed': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'background.accent.onContent.disabled': {
        default: cocoaBrownPalette.desertSand,
        _dark: cocoaBrownPalette.desertSand
    },
    'background.feedback.success.default': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'background.feedback.success.hovered': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'background.feedback.success.pressed': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'background.feedback.success.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.feedback.warning.default': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'background.feedback.warning.hovered': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'background.feedback.warning.pressed': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'background.feedback.warning.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.feedback.error.default': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'background.feedback.error.hovered': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'background.feedback.error.pressed': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'background.feedback.error.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'background.error.success.default': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'background.error.success.hovered': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'background.error.success.pressed': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'background.error.success.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'text.neutral.primary.default': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'text.neutral.primary.hovered': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'text.neutral.primary.pressed': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'text.neutral.primary.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'text.neutral.secondary.default': {
        default: raisinBlackPalette.davyGray,
        _dark: raisinBlackPalette.davyGray
    },
    'text.neutral.secondary.hovered': {
        default: raisinBlackPalette.davyGray,
        _dark: raisinBlackPalette.davyGray
    },
    'text.neutral.secondary.pressed': {
        default: raisinBlackPalette.davyGray,
        _dark: raisinBlackPalette.davyGray
    },
    'text.neutral.secondary.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'text.neutral.inverse.default': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'text.neutral.inverse.hovered': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'text.neutral.inverse.pressed': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'text.neutral.inverse.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'text.accent.primary.default': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'text.accent.primary.hovered': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'text.accent.primary.pressed': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'text.accent.primary.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'text.feedback.success.default': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'text.feedback.success.hovered': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'text.feedback.success.pressed': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'text.feedback.success.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'text.feedback.warning.default': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'text.feedback.warning.hovered': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'text.feedback.warning.pressed': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'text.feedback.warning.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'text.feedback.error.default': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'text.feedback.error.hovered': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'text.feedback.error.pressed': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'text.feedback.error.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'icon.neutral.primary.default': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'icon.neutral.primary.hovered': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'icon.neutral.primary.pressed': {
        default: raisinBlackPalette.raisinBlack,
        _dark: raisinBlackPalette.raisinBlack
    },
    'icon.neutral.primary.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'icon.neutral.secondary.default': {
        default: raisinBlackPalette.davyGray,
        _dark: raisinBlackPalette.davyGray
    },
    'icon.neutral.secondary.hovered': {
        default: raisinBlackPalette.davyGray,
        _dark: raisinBlackPalette.davyGray
    },
    'icon.neutral.secondary.pressed': {
        default: raisinBlackPalette.davyGray,
        _dark: raisinBlackPalette.davyGray
    },
    'icon.neutral.secondary.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'icon.neutral.inverse.default': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'icon.neutral.inverse.hovered': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'icon.neutral.inverse.pressed': {
        default: whiteSmokePalette.whiteSmoke,
        _dark: whiteSmokePalette.whiteSmoke
    },
    'icon.neutral.inverse.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'icon.accent.primary.default': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'icon.accent.primary.hovered': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'icon.accent.primary.pressed': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'icon.accent.primary.disabled': {
        default: raisinBlackPalette.silver,
        _dark: raisinBlackPalette.silver
    },
    'icon.feedback.success.default': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'icon.feedback.success.hovered': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'icon.feedback.success.pressed': {
        default: intentPalette.green,
        _dark: intentPalette.green
    },
    'icon.feedback.success.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'icon.feedback.warning.default': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'icon.feedback.warning.hovered': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'icon.feedback.warning.pressed': {
        default: intentPalette.orange,
        _dark: intentPalette.orange
    },
    'icon.feedback.warning.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'icon.feedback.error.default': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'icon.feedback.error.hovered': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'icon.feedback.error.pressed': {
        default: intentPalette.red,
        _dark: intentPalette.red
    },
    'icon.feedback.error.disabled': {
        default: raisinBlackPalette.softSand,
        _dark: raisinBlackPalette.softSand
    },
    'border.neutral.primary.default': {
        default: umberPalette.timberwolf,
        _dark: umberPalette.timberwolf
    },
    'border.neutral.primary.hovered': {
        default: umberPalette.timberwolf,
        _dark: umberPalette.timberwolf
    },
    'border.neutral.primary.pressed': {
        default: umberPalette.timberwolf,
        _dark: umberPalette.timberwolf
    },
    'border.neutral.primary.focused': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'border.neutral.primary.disabled': {
        default: raisinBlackPalette.dullSand,
        _dark: raisinBlackPalette.dullSand
    },
    'border.accent.primary.default': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'border.accent.primary.hovered': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'border.accent.primary.pressed': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'border.accent.primary.focused': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'border.accent.primary.disabled': {
        default: raisinBlackPalette.dullSand,
        _dark: raisinBlackPalette.dullSand
    },
    'border.accent.secondary.default': {
        default: cocoaBrownPalette.cocoaBrown,
        _dark: cocoaBrownPalette.cocoaBrown
    },
    'border.accent.secondary.hovered': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'border.accent.secondary.pressed': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'border.accent.secondary.focused': {
        default: cocoaBrownPalette.brown,
        _dark: cocoaBrownPalette.brown
    },
    'border.accent.secondary.disabled': {
        default: raisinBlackPalette.dullSand,
        _dark: raisinBlackPalette.dullSand
    }
};

//# sourceMappingURL=colors.js.map